import axios from 'axios'
import type {
  HospitalLocationType,
  HospitalLocationTypeWritePayload,
  PaginatedResponse,
} from '@/modules/settings/types/hospitalStructure.types'
import { BASE_URL } from '@/environment/environment'

const API_URL = `${BASE_URL}/api/hospital/location-types`

function unwrapList(data: PaginatedResponse<HospitalLocationType> | HospitalLocationType[]): HospitalLocationType[] {
  return Array.isArray(data) ? data : (data.results || [])
}

export const locationTypesApi = {
  async list(params?: { search?: string }): Promise<HospitalLocationType[]> {
    const { data } = await axios.get<PaginatedResponse<HospitalLocationType> | HospitalLocationType[]>(`${API_URL}/`, {
      params,
    })
    return unwrapList(data)
  },

  async create(payload: HospitalLocationTypeWritePayload): Promise<HospitalLocationType> {
    const { data } = await axios.post<HospitalLocationType>(`${API_URL}/`, payload)
    return data
  },

  async update(id: string, payload: Partial<HospitalLocationTypeWritePayload>): Promise<HospitalLocationType> {
    const { data } = await axios.patch<HospitalLocationType>(`${API_URL}/${id}/`, payload)
    return data
  },

  async remove(id: string): Promise<void> {
    await axios.delete(`${API_URL}/${id}/`)
  },
}
